// src/pages/Catalog.js
import React from 'react';
import SeoHead from '../seo/SeoHead';
import CatalogHero from '../main/CatalogHero';
import CatalogItems from '../main/CatalogItems';

export default function Catalog() {
  return (
    <>
      <SeoHead
        title="Buy Moroccan Olive Oil – Marrakech Reserve"
        description="Explore our full catalog of premium Marrakech Reserve olive oils, hand‑harvested and cold‑pressed for unmatched quality."
        url="https://marrakech-reserve.com/products"
        keywords={
          "olive oil from Morocco, olive oil, extra virgin olive oil, premium olive oil, olive oil from marrakech, " +
          "organic olive oil, cold-pressed olive oil, artisanal olive oil, gourmet olive oil, " +
          "small-batch olive oil, Moroccan olive oil, reserve olive oil, authentic Moroccan olive oil, " +
          "buy olive oil, buy olive oil from Morocco, hand-harvested olive oil, natural olive oil, " +
          "luxury olive oil, flavored olive oil, culinary olive oil, healthy cooking oil"
        }
      />
      <CatalogHero />
      <CatalogItems />
    </>
  );
}
